import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const HISTORIC_CODE_TEXT = "Confirmed diagnosis from previous episode";

export const HistoricCodeBadge = () => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" aria-label={HISTORIC_CODE_TEXT} className="shrink-0 cursor-help">
          <span aria-hidden="true">✅</span>
        </button>
      </TooltipTrigger>
      <TooltipContent>{HISTORIC_CODE_TEXT}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
